export const deliveryPackageConstants = {
  // GET_ALL: 取得所有貨運包裹
  GET_ALL_REQUEST: "DELIVERY_PACKAGE_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "DELIVERY_PACKAGE_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "DELIVERY_PACKAGE_GET_ALL_FAILURE",
  RESET_ALL_SUCCESS: "DELIVERY_PACKAGE_RESET_ALL_SUCCESS",
  // CREATE_DELIVERY_PACKAGE: 建立貨運包裹
  CREATE_DELIVERY_PACKAGE_REQUEST: "DELIVERY_PACKAGE_CREATE_DELIVERY_PACKAGE_REQUEST",
  CREATE_DELIVERY_PACKAGE_DONE: "DELIVERY_PACKAGE_CREATE_DELIVERY_PACKAGE_DONE",
  // GET_TYPE_OPTIONS: 取得貨運包裹類型選項
  GET_TYPE_OPTIONS_REQUEST: "DELIVERY_PACKAGE_GET_TYPE_OPTIONS_REQUEST",
  GET_TYPE_OPTIONS_SUCCESS: "DELIVERY_PACKAGE_GET_TYPE_OPTIONS_SUCCESS",
  GET_TYPE_OPTIONS_FAILURE: "DELIVERY_PACKAGE_GET_TYPE_OPTIONS_FAILURE",
  RESET_TYPE_OPTIONS_SUCCESS: "DELIVERY_PACKAGE_RESET_TYPE_OPTIONS_SUCCESS",
  // GET_DELIVER_BY_OPTIONS: 取得貨運包裹貨運類型選項
  GET_DELIVER_BY_OPTIONS_REQUEST: "DELIVERY_PACKAGE_GET_DELIVER_BY_OPTIONS_REQUEST",
  GET_DELIVER_BY_OPTIONS_SUCCESS: "DELIVERY_PACKAGE_GET_DELIVER_BY_OPTIONS_SUCCESS",
  GET_DELIVER_BY_OPTIONS_FAILURE: "DELIVERY_PACKAGE_GET_DELIVER_BY_OPTIONS_FAILURE",
  RESET_DELIVER_BY_OPTIONS_SUCCESS: "DELIVERY_PACKAGE_RESET_DELIVER_BY_OPTIONS_SUCCESS",
  // GET_PRESERVE_OPTIONS: 取得貨運包裹保存選項
  GET_PRESERVE_OPTIONS_REQUEST: "DELIVERY_PACKAGE_GET_PRESERVE_OPTIONS_REQUEST",
  GET_PRESERVE_OPTIONS_SUCCESS: "DELIVERY_PACKAGE_GET_PRESERVE_OPTIONS_SUCCESS",
  GET_PRESERVE_OPTIONS_FAILURE: "DELIVERY_PACKAGE_GET_PRESERVE_OPTIONS_FAILURE",
  RESET_PRESERVE_OPTIONS_SUCCESS: "DELIVERY_PACKAGE_RESET_PRESERVE_OPTIONS_SUCCESS"
};
